<template>
  <div id="modalNovaRegua">
    <q-dialog v-model="OpenDialogNovaRegua" persistent>
      <q-card style="width: 400px !important">
        <q-card-section class="row items-center">
          <div class="text-h6">{{valueQuando.isNew ? 'Nova ' : 'Editar '}} Régua de Mensagens</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup @click="closeModal()" />
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="q-pa-none">
            <div class="q-col-gutter-md row">
              <div class="col-12 col-md-12">
                <q-select
                  dense
                  v-model="tipoReguaSelecionado"
                  :options="tiposRegua"
                  label="Regua de"
                >
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">Sem Resultados</q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </div>
              <div class="col-12 col-md-12">
                <q-radio v-model="quandoEnvia" val="antes" :label="origemIsVendaOnline ? 'Antes do vencimento do link' : 'Enviar Antes'" :disable="disableQuandoEnvia">
                  <template v-slot:default >
                    <q-icon
                      style="margin-left:10px"
                      color="grey"
                      size='23px'
                      name="info"
                      class="cursor-pointer"
                    >
                      <q-tooltip v-if="origemIsVendaOnline" max-width='400px' :style="{fontSize:'15px'}">{{textos.enviaVendaOnlineAntes}}</q-tooltip>
                      <q-tooltip v-else-if="tipoReguaSelecionado == 'Email'" max-width='400px' :style="{fontSize:'15px'}">{{textos.enviaEmailAntes}}</q-tooltip>
                      <q-tooltip v-else-if="tipoReguaSelecionado == 'WhatsApp'" max-width='400px' :style="{fontSize:'15px'}">{{textos.enviaAntes}}</q-tooltip>
                    </q-icon>
                  </template>
                </q-radio>
                <q-radio v-model="quandoEnvia" val="depois" :label="origemIsVendaOnline ? 'Depois da geração do link' : 'Enviar Depois'">
                  <template v-slot:default >
                    <q-icon
                      style="margin-left:10px"
                      color="grey"
                      size='23px'
                      name="info"
                      class="cursor-pointer"
                    >
                      <q-tooltip v-if="origemIsVendaOnline" max-width='400px' :style="{fontSize:'15px'}">{{textos.enviaVendaOnlineDepois}}</q-tooltip>
                      <q-tooltip v-else-if="tipoReguaSelecionado == 'Email'" max-width='400px' :style="{fontSize:'15px'}">{{textos.enviaEmailDepois}}</q-tooltip>
                      <q-tooltip v-else-if="tipoReguaSelecionado == 'WhatsApp'" max-width='400px' :style="{fontSize:'15px'}">{{textos.enviaDepois}}</q-tooltip>
                    </q-icon>
                  </template>
                </q-radio>
              </div>

              <div class="col-12 col-md-6">
                <q-input
                  v-model="quando"
                  label="Digite Quanto"
                  bottom-slots
                  :error="errors.quando ? true : false"
                >
                  <template v-slot:error>
                    <span v-for="(error, i) in errors.quando" :key="error + i">{{error}}</span>
                  </template>
                </q-input>
              </div>
              <div v-if="!unidadeEditavel" class="col-12 col-md-6">
                <q-select
                  v-model="unidadeDias"
                  label="Unidade"
                  bottom-slots
                  disable
                >
                </q-select>
              </div>
              <div v-else class="col-12 col-md-6">
                <q-select
                  v-model="unidadesTempoSelecionado"
                  :options="unidadesTempo"
                  label="Unidade"
                  bottom-slots
                  option-label="descricao"
                  option-value="value"
                >
                </q-select>
              </div>

              <div v-if="tipoReguaSelecionado == 'Email' || tipoReguaSelecionado == 'Webhook'" class="col-12 q-pt-none">
                <q-select
                  dense
                  v-model="origemSelecionado"
                  :options="origemEmail"
                  label="De Onde"
                  bottom-slots
                  :error="errors.origem ? true : false"
                  option-label="descricao"
                  option-value="tipo"
                >
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">Sem Resultados</q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </div>

              <div v-if="tipoReguaSelecionado == 'WhatsApp'" class="col-12 q-pt-none">
                  <q-select
                    dense
                    clearable
                    v-model="origemWppSelecionado"
                    :options="origemWpp"
                    label="De Onde"
                    bottom-slots
                    :error="errors.origem ? true : false"
                    option-label="descricao"
                    option-value="tipo"
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">Sem Resultados</q-item-section>
                      </q-item>
                    </template>
                  </q-select>
              </div>

              <div v-if="tipoReguaSelecionado == 'Webhook'" class="col-12 q-pt-none">
                <q-select
                  dense
                  clearable
                  v-model="webhookSelecionado"
                  :options="webhooks"
                  label="Webhook"
                  bottom-slots
                  :error="errors.webhook_id ? true : false"
                  option-label="descricao"
                  option-value="id"
                >
                  <template v-slot:error>
                    <span v-for="(error, i) in errors.webhook_id" :key="error + i">{{error}}</span>
                  </template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">Sem Resultados</q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </div>

              <div class="col-12 q-pt-none">
                <q-select
                  dense
                  clearable
                  v-model="templateSelecionado"
                  :options="optionsTemplates"
                  :label="tipoReguaSelecionado == 'Email'? 'Template de E-mail': 'Template de WhatsApp'"
                  bottom-slots
                  :error="errors.template_id ? true : false"
                  :option-label="value => value === null ? 'Item Vazio' : value.title"
                  :option-value="value => value === null ? null : value"
                  v-if="tipoReguaSelecionado != 'Webhook'"
                >
                  <template v-slot:error>
                    <span v-for="(error, i) in errors.template_id" :key="error + i">{{error}}</span>
                  </template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">Sem Resultados</q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </div>

              <div v-if="!origemIsVendaOnline" class="col-6 q-pt-none">
                <q-input
                  dense
                  label="Horário de envio"
                  v-model="reguaHorario"
                  mask="time"
                  :rules="['time']"
                  @click="() => $refs.qHorarioRegua.show()"
                >
                  <template v-slot:append>
                    <q-icon name="access_time" class="cursor-pointer">
                      <q-popup-proxy
                        ref="qHorarioRegua"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-time
                          v-model="reguaHorario"
                          @update:model-value="() => $refs.qHorarioRegua.hide()"
                        >
                          <div class="row items-center justify-end">
                            <q-btn v-close-popup label="Close" color="primary" flat />
                          </div>
                        </q-time>
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>

              <div class="col-6 q-pt-none">
                <q-select
                    dense
                    v-model="tagsSelecionadas"
                    multiple
                    use-chips
                    clearable
                    label="Tags"
                    bottom-slots
                    option-label="title"
                    option-value="id"
                    :options="allTags"
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">Sem Resultados</q-item-section>
                      </q-item>
                    </template>
                  </q-select>
              </div>

              <div class="col-12 q-pt-none">
                <q-input
                  dense
                  v-model="reguaNameWrite"
                  label="Nome Regua"
                  >
                  <template v-slot:append >
                    <q-icon
                      style="margin-left:10px"
                      color="grey"
                      size='23px'
                      name="info"
                      class="cursor-pointer"
                    >
                      <q-tooltip max-width='400px' :style="{fontSize:'15px'}">{{textos.nomeRegua}}</q-tooltip>
                    </q-icon>
                  </template>
                </q-input>
              </div>

              <div class="col-12 q-pt-md" v-if="previewDescricaoRegua">
                <div class="text-caption text-grey-7 q-mb-xs">Prévia da Descrição:</div>
                <div class="q-pa-sm bg-grey-2 rounded-borders text-body2">
                  {{ previewDescricaoRegua }}
                </div>
              </div>

            </div>

          </div>
        </q-card-section>
        <q-card-actions class="pull-right q-pa-md">

            <q-btn
              no-wrap
              v-ripple
              label="Salvar"
              no-caps
              class="bg-positive text-white"
              clickable
              :loading="salvando"
              @click="salvar()"
            >
              <template v-slot:loading>
                <q-spinner color="grey-10" size="1em" />
              </template>
            </q-btn>

        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/axios-auth";
import { Notify } from "quasar";
export default {
  name: "modal-nova-regua",
  data() {
    return {
      optionsTemplates: null,
      webhooks: [],
      webhookSelecionado: null,
      salvando: false,
      reguaNameWrite: "",
      enviaAntes: true,
      unidadeDias: "Dias",
      quandoEnvia: 'antes',
      quando: 0,
      descricao: "",
      tipoReguaSelecionado: 'Email',
      origemWppSelecionado: null,
      origemSelecionado: { descricao: "Boleto, Pix em Aberto", tipo: 'boleto' },
      unidadesTempoSelecionado: { descricao: "Dias", value: "dias"},
      errors: [],
      tagsSelecionadas: [],
      templateSelecionado: null,
      textos:{
        enviaAntes:'As mensagens serão enviadas antes da data do evento.',
        enviaDepois:'As mensagens serão enviadas depois da data do evento.',
        enviaEmailAntes:'Os e-mails serão enviadas antes da data de vencimento.',
        enviaEmailDepois:'Os e-mails serão enviadas depois da data de vencimento.',
        enviaVendaOnlineAntes:'O lembrete é enviado antes do link da venda vencer, enquanto a venda estiver aberta. Vendas pagas, canceladas ou expiradas não recebem.',
        enviaVendaOnlineDepois:'O lembrete é enviado depois da geração do link, enquanto a venda estiver aberta. Vendas pagas, canceladas ou expiradas não recebem.',
        nomeRegua:'Se um nome não for escrito, será criado um baseado nas configurações desta regua. Você pode ver uma prévia da descrição automática abaixo.'
      },
      reguaHorario: '00:00',
      tiposRegua: ['Email', 'WhatsApp', 'Webhook'],
      origemEmail: [
        { descricao: "Boleto, Pix em Aberto", tipo: 'boleto' },
        { descricao: "Cartão de Crédito", tipo: 'cartao' },
        { descricao: "Faturas", tipo: 'faturas' },
        { descricao: "Venda online", tipo: 'vendas-online' }
      ],
      origemWpp: [
        { descricao: "Boletos", tipo: 'movcontas' },
        { descricao: "Agenda", tipo: 'calendario' },
        { descricao: "Cadastros", tipo: 'cadastros' },
        { descricao: "Boletos Liquidados", tipo: 'faturas-liquidadas' },
        { descricao: "Mensagens", tipo: 'mensagens' },
        { descricao: "Venda online", tipo: 'vendas-online' }
      ],
      unidadesTempo: [
        { descricao: "Dias", value: "dias" },
        { descricao: "Horas", value: "horas" },
        { descricao: "Minutos", value: "minutos" }
      ]
    };
  },
  methods: {
    closeModal() {
      this.errors = [];
      this.templateSelecionado = null;
      this.webhookSelecionado = null;
      this.tipoReguaSelecionado = "Email";
      this.unidadesTempoSelecionado = { descricao: "Dias", value: "dias"};
      this.origemWppSelecionado = null;
      this.tagsSelecionadas = [];
      this.quando = 0;
      this.descricao = "";
      this.outraData = false;
      this.enviaAntes = true;
      this.reguaNameWrite = "";

      this.$store.commit("OpenDialogNovaRegua", false);
      this.$store.commit("OpenDialogTags", false);
      this.errors = [];
      this.$store.commit("valueQuando", {});
    },

    salvar() {
      if (this.templateSelecionado === null && this.tipoReguaSelecionado !== "Webhook") {
        this.errors = {
          template_id: {
            required: "Um template precisa ser escolhido!"
          }
        };
        return false;
      }
      if (this.webhookSelecionado === null && this.tipoReguaSelecionado === "Webhook") {
        this.errors = {
          webhook_id: {
            required: "Um webhook precisa ser escolhido!"
          }
        };
        return false;
      }
      if(this.origemWppSelecionado === null && this.tipoReguaSelecionado == "WhatsApp") {
        this.errors = {
          origem: {
            required: "Uma origem precisa ser escolhida!"
          }
        };
        return false;
      }

      if (!this.origemIsVendaOnline && String(this.reguaHorario).split(":").length === 0) {
        this.errors = {
          horario: {
            required: "Um horário precisa ser informado!",
          },
        };
        return false;
      }

      let [horarioRegua] = String(this.reguaHorario).split(":");
      horarioRegua = this.origemIsVendaOnline ? 0 : parseInt(horarioRegua);

      if (Number.isNaN(horarioRegua) || horarioRegua < 0 || horarioRegua > 24) {
        this.errors = {
          horario: {
            required: "Escolha um horário válido!",
          },
        };
        return false;
      }

      this.errors = [];
      let dados = {};

      if (this.tipoReguaSelecionado !== "Webhook") {
        dados.template_id = this.templateSelecionado.id;
      } else {
        dados.webhook_id = this.webhookSelecionado.id;
      }

      dados.horario = horarioRegua;

      this.quandoEnvia == "antes" && this.quando !== 0? dados.quando = this.quando * -1: dados.quando = Number(this.quando);

      if (this.tipoReguaSelecionado == "Email") {
        dados.unidade = this.origemIsVendaOnline ? this.unidadesTempoSelecionado.value : "dias";
        dados.tipo = 1;
        dados.origem = this.origemSelecionado.tipo;
        dados.descricao = this.gerarDescricaoRegua();
      } else if (this.tipoReguaSelecionado == "WhatsApp") {
        dados.unidade = this.origemIsBoleto ? "dias" : this.unidadesTempoSelecionado.value;
        dados.tipo = 2;
        dados.origem = this.origemWppSelecionado.tipo;

        if (this.tagsSelecionadas.length > 0) {
          dados.tags = this.tagsSelecionadas.map((tag) => tag.id);
        }

        dados.descricao = this.gerarDescricaoRegua();
      } else if (this.tipoReguaSelecionado == "Webhook") {
        dados.unidade = "dias";
        dados.tipo = 3;
        dados.origem = this.origemSelecionado.tipo;
        dados.descricao = this.gerarDescricaoRegua();
      }
      this.salvando = true;

      axios
        .post("/regua-cobrancas/add", dados)
        .then(res => {
          if (res.data.success) {
            Notify.create({
              message: res.data.message,
              color: "green",
              position: "top-right"
            });

            this.$store.dispatch("reguaDeCobranca");
            this.closeModal();
          } else {
            this.errors = res.data.errors;
            Notify.create({
              message: res.data.message,
              color: "orange",
              position: "top-right"
            });
          }
          this.salvando = false;
        })
        .catch(() => {
          Notify.create({
            message:
              "Não foi possível adicionar a régua de cobrança, ou você não possui permissão para isto!",
            color: "red",
            position: "top-right"
          });
          this.$store.dispatch("reguaDeCobranca");
          this.salvando = false;
        });
    },

    gerarDescricaoRegua() {
      // Se o usuário digitou um nome personalizado, retorna ele
      if (this.reguaNameWrite !== "") {
        return this.reguaNameWrite;
      }

      if (this.origemIsVendaOnline && this.tipoReguaSelecionado !== "Webhook") {
        return this.gerarDescricaoVendaOnline();
      }

      // Caso contrário, gera uma descrição automática baseada no tipo
      const horarioFormatado = this.reguaHorario ? ` às ${this.reguaHorario}` : '';

      if (this.tipoReguaSelecionado == "Email") {
        const templateText = this.templateSelecionado?.subject || "Template";
        return templateText + " via " + this.tipoReguaSelecionado + ", " + this.quando + " dia(s) " + this.quandoEnvia + " do vencimento do Boleto" + horarioFormatado + ".";
      } else if (this.tipoReguaSelecionado == "WhatsApp") {
        const descricaoTags = this.tagsSelecionadas.map((tag) => tag.title);
        let unidadeTempo = "";
        let origem = "";

        if (this.origemIsBoleto || this.unidadesTempoSelecionado.value == 'dias') unidadeTempo = " Dia(s) ";
        else if (this.unidadesTempoSelecionado.value == 'horas') unidadeTempo = " Hora(s) ";
        else unidadeTempo = " Minuto(s) ";

        if (this.origemWppSelecionado?.tipo == "movcontas") origem = " do vencimento do Boleto";
        else if (this.origemWppSelecionado?.tipo == "calendario") origem = " do evento na Agenda";
        else if (this.origemWppSelecionado?.tipo == "cadastros") origem = " do Cadastro";
        else if (this.origemWppSelecionado?.tipo == "faturas-liquidadas") origem = " do Boleto Liquidado";
        else origem = " da expiração da Mensagem";

        const templateText = this.templateSelecionado?.subject || "Template";
        let descricao = templateText + " via " + this.tipoReguaSelecionado + ", " + this.quando + unidadeTempo + this.quandoEnvia + origem + horarioFormatado + ".";

        if (descricaoTags.length > 0) {
          descricao = descricao.replace(".", ". Tags: " + descricaoTags.join(", ") + ".");
        }

        return descricao;
      } else if (this.tipoReguaSelecionado == "Webhook") {
        const webhookText = this.webhookSelecionado?.descricao || "Webhook";
        return webhookText + " via Webhook, " + this.quando + " dia(s) " + this.quandoEnvia + " do evento" + horarioFormatado + ".";
      }

      return "";
    },

    gerarDescricaoVendaOnline() {
      const unidades = { dias: " Dia(s) ", horas: " Hora(s) ", minutos: " Minuto(s) " };
      const gatilho = this.quandoEnvia === "antes" ? "antes do vencimento do link" : "depois da geração do link";
      const templateText = this.templateSelecionado?.subject || "Template";

      return templateText + " via " + this.tipoReguaSelecionado + ", " + this.quando + unidades[this.unidadesTempoSelecionado.value] + gatilho + ".";
    },

    recarregarTemplatesSeMudouVendaOnline(novo, antigo) {
      const eraVendaOnline = antigo?.tipo === "vendas-online";
      const eVendaOnline = novo?.tipo === "vendas-online";
      if (eraVendaOnline === eVendaOnline && !(antigo?.tipo === "cartao" || novo?.tipo === "cartao")) {
        return;
      }

      this.templateSelecionado = null;
      this.buscaTemplates();
    },

    addTagRegua() {
      this.$store.dispatch("addTag");
    },
    buscaTemplates() {
      let params = null;
      if(this.tipoReguaSelecionado === "Email"){
          params = {
            tipo: this.origemIsVendaOnline ? "vendaonline" : "boleto",
          };
          if (this.origemSelecionado && this.origemSelecionado.tipo === "cartao") {
            params = {
              tipo: "cartao",
            };
          }
      }else if (this.tipoReguaSelecionado == "WhatsApp"){
        params = {
          tipo: this.origemIsVendaOnline ? "vendaonline-whatsapp" : "whatsapp",
        };
      }

      axios
        .get("/templates", {
          params: params
        })
        .then(res => {
          if (res.data.success) {
            this.optionsTemplates = res.data.data.templates;
          }
        })
        .catch(err => {
          Notify.create({
            message: "Houve um erro ao buscar os templates",
            color: "red",
            position: "top-right"
          });
        });
    },
    buscaWebhooks() {
      axios
        .get("/webhooks")
        .then(res => {
          if (res.data.success) {
            this.webhooks = res.data.data.filter(webhook => webhook.acao === "executarRegua");
          }
        })
        .catch(err => {
          Notify.create({
            message: "Houve um erro ao buscar os webhooks",
            color: "red",
            position: "top-right"
          });
        });
    }
  },
  computed: {
    ...mapGetters([
      "valueQuando",
      "allTags"
    ]),
    OpenDialogNovaRegua: {
      get() {
        return this.$store.getters.OpenDialogNovaRegua;
      },
      set() {}
    },
    origemIsBoleto() {
      return this.origemWppSelecionado && this.origemWppSelecionado.descricao === "Boletos";
    },
    origemIsVendaOnline() {
      if (this.tipoReguaSelecionado === "WhatsApp") {
        return this.origemWppSelecionado?.tipo === "vendas-online";
      }

      return this.tipoReguaSelecionado === "Email" && this.origemSelecionado?.tipo === "vendas-online";
    },
    unidadeEditavel() {
      return this.origemIsVendaOnline || (this.tipoReguaSelecionado === "WhatsApp" && !this.origemIsBoleto);
    },
    disableQuandoEnvia() {
      return (this.origemSelecionado && this.origemSelecionado.tipo === "faturas")
       || (this.origemWppSelecionado && this.origemWppSelecionado.tipo === "faturas");
    },
    previewDescricaoRegua() {
      return this.gerarDescricaoRegua();
    }
  },
  mounted() {
  },
  watch: {
    tipoReguaSelecionado(val){
      if(val === "Email" || val === "WhatsApp"){
        this.buscaTemplates();
      } else if(val === "Webhook") {
        this.buscaWebhooks();
      }
    },
    OpenDialogNovaRegua(val){
      if (val){
        this.addTagRegua();
        if (this.tipoReguaSelecionado === "Email" || this.tipoReguaSelecionado === "WhatsApp") {
          this.buscaTemplates();
        } else if (this.tipoReguaSelecionado === "Webhook") {
          this.buscaWebhooks();
        }
      }
    },
    reguaHorario() {
      // Trigger para atualizar a computed property previewDescricaoRegua
      // quando o horário de envio for alterado
      this.$forceUpdate();
    },
    quando() {
      // Atualiza a descrição quando a quantidade de tempo for alterada
      this.$forceUpdate();
    },
    quandoEnvia() {
      // Atualiza a descrição quando mudar entre "antes" e "depois"
      this.$forceUpdate();
    },
    templateSelecionado() {
      // Atualiza a descrição quando o template for alterado
      this.$forceUpdate();
    },
    webhookSelecionado() {
      // Atualiza a descrição quando o webhook for alterado
      this.$forceUpdate();
    },
    origemWppSelecionado(novo, antigo) {
      // Atualiza a descrição quando a origem do WhatsApp for alterada
      this.$forceUpdate();
      this.recarregarTemplatesSeMudouVendaOnline(novo, antigo);
    },
    origemSelecionado(novo, antigo) {
      // Atualiza a descrição quando a origem for alterada
      this.$forceUpdate();
      this.recarregarTemplatesSeMudouVendaOnline(novo, antigo);
    },
    unidadesTempoSelecionado() {
      // Atualiza a descrição quando a unidade de tempo for alterada
      this.$forceUpdate();
    },
    tagsSelecionadas: {
      handler() {
        // Atualiza a descrição quando as tags forem alteradas
        this.$forceUpdate();
      },
      deep: true
    }
  }
};
</script>

